module.exports = __webpack_public_path__ + "static/media/pix.9d2d713f.csv";